import { IconButton, Tooltip, Typography, useTranslate } from '@prenuvo/halo';
import { Duplicat } from '@prenuvo/halo-icon';

import { useCopyPatientDetailsData } from './use-copy-patient-details-data.hook';

export function CopyPatientDetails() {
  const translate = useTranslate();

  const clipboardData = useCopyPatientDetailsData();

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(clipboardData);
  };

  return (
    <Tooltip
      content={<Typography translationKey="FCT.REPORTING.HEADER.ACTIONS.COPY_STUDY_DETAILS" />}
      side="bottom"
    >
      <IconButton
        aria-label={translate('FCT.REPORTING.HEADER.ACTIONS.COPY_STUDY_DETAILS')}
        data-testid="copy-patient-summary-button"
        icon={Duplicat}
        onClick={handleCopyToClipboard}
        size="sm"
        variant="text"
      />
    </Tooltip>
  );
}
